import { forwardRef } from "react";
import { styled } from "goober";

import { autoScaleUp } from "@/game-tft/InGameShared.jsx";

export const ToolTipBox = styled("div", forwardRef)``;
export const TooltipContainer = styled("div")`
  width: 173px;
  height: auto;
  font-size: var(--sp-3) !important;
  color: var(--shade1);
  background: var(--shade10);
  border-radius: var(--br);
  position: relative;
  display: block;
  transform: scale(${autoScaleUp()});
  transform-origin: top center;

  filter: drop-shadow(0 var(--sp-1) var(--sp-3) var(--shade10-25));

  .unit-tooltip {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--white);
    font-size: var(--sp-3);
    font-weight: 700;
    border-radius: var(--br);
    padding: 5px;
  }

  .main-area {
    position: relative;
  }

  .imgOverlay {
    background: linear-gradient(
      66.84deg,
      rgba(7, 14, 29, 0.8) 11.77%,
      rgba(7, 14, 29, 0.51) 44.28%,
      rgba(7, 14, 29, 0) 67.49%
    );
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 2;
    height: auto;
  }

  img {
    object-fit: cover;
    object-position: right top;
    height: 97px;
    width: 100%;
  }

  .unit-traits {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    position: absolute;
    bottom: var(--sp-2);
    left: var(--sp-2);
    filter: drop-shadow(0 var(--sp-0_5) var(--sp-5) #000000);
    z-index: 5;
  }

  .unit-trait {
    display: flex;
    align-items: center;
    margin-top: var(--sp-1);
    color: var(--white);
  }

  .unit-trait svg,
  .unit-trait div {
    width: var(--sp-5);
    height: var(--sp-5);
  }

  .unit-trait .trait_icon {
    width: 70%;
  }

  .hover-bottom {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: var(--sp-1_5) var(--sp-1_5) 0 var(--sp-1_5);
  }

  .unit-traits span {
    margin-left: var(--sp-1);
  }

  .unit-cost {
    display: flex;
    align-items: center;
  }

  .unit-cost svg {
    margin-right: var(--sp-0_5);
    color: #efbf6c;
    margin-top: var(--sp-0_5);
  }
`;
export const Cost = styled("div")`
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  & > svg {
    width: var(--sp-4);
    height: var(--sp-4);
    & * {
      fill: var(--yellow);
      stroke: var(--yellow);
    }
  }
`;

export const TooltipStatsContainer = styled("div")`
  width: 100%;

  hr {
    width: 100%;
    border: none;
    border-top: 1px solid var(--shade6);
  }

  .statsSection {
    width: 100%;
    padding: var(--sp-1_5);
    padding-top: 0;
  }

  .statsRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`;
